import { createActions } from 'redux-actions';
import { UPDATE_ACHIEVEMENT } from '../actionTypes';

export default createActions({
  [UPDATE_ACHIEVEMENT]: (state) => {
    return state;
  }
});
